<ui-modal
  class="delta-by-tenor-modal"
  [isOpened]="isModalOpened"
  modalTitle="Delta by Tenor"
  (isOpenedChange)="modalChanged($event)"
>
  <div class="body">
    <div class="main-margin">
      <label>
        Currency Pair
        <div class="selector-container">
          <app-selector
            class="currency-pair"
            [defaultValue]="defaultValue"
            [passedItems]="activeCurrencyPairs"
            (valueEmitter)="onCurrencyPairChange($event.value)"
          ></app-selector>
        </div>
      </label>
    </div>

    <div class="main-margin table-container">
      <table ui-table id="table-data">
        <thead>
          <tr>
            <th>Tenor</th>

            <th>
              Delta
              {{
                currencySelected
                  ? '(' + (currencySelected | slice: 0:3) + ')'
                  : null
              }}
            </th>
          </tr>
        </thead>
        <tbody>
          <div class="spinner-container" *ngIf="fetchingResponse">
            <loading-spinner class="spinner-container"></loading-spinner>
          </div>

          <div class="message-container" *ngIf="errorMessage">
            {{ errorMessage }}
          </div>

          <div
            class="message-container"
            *ngIf="
              activeCurrencyPairs.length > 0 &&
              !currencySelected &&
              !fetchingResponse &&
              !errorMessage
            "
          >
            Select a currency pair
          </div>

          <div
            class="message-container"
            *ngIf="
              legComponents.length === 0 && !fetchingResponse && !errorMessage
            "
          >
            Create or load a leg
          </div>

          <div
            class="message-container"
            *ngIf="
              legComponents.length > 0 &&
              activeCurrencyPairs.length === 0 &&
              !fetchingResponse &&
              !errorMessage
            "
          >
            None of the legs have a currency Pair available
          </div>
          <tr *ngFor="let item of data; index as i">
            <td>{{ item.tenor }}</td>
            <td>{{ item.value | number: '1.0-0' }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <hr class="hard-return" />
  <div class="modal-footer">
    <button type="button" class="ui-button" (click)="modalChanged(false)">
      Cancel
    </button>

    <button
      type="button"
      class="ui-button primary"
      (click)="onCopyToClipboardClicked()"
    >
      Copy to Clipboard
    </button>
  </div>
</ui-modal>
